import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const BrandingContext = createContext(null);

const DEFAULTS = {
  primary_dark: "#1a1a1a",
  accent_orange: "#F05A14",
  heading_bg: "#f1f5f9",
  logo_data_url: "/brand/newell-logo.png",
  accreditations_data_url: "/brand/newell-accreditations.png",
};

function applyCssVars(b) {
  const r = document.documentElement;
  r.style.setProperty("--brand-primary", b.primary_dark || DEFAULTS.primary_dark);
  r.style.setProperty("--brand-accent", b.accent_orange || DEFAULTS.accent_orange);
  r.style.setProperty("--brand-heading-bg", b.heading_bg || DEFAULTS.heading_bg);
}

export function BrandingProvider({ children }) {
  const [b, setB] = useState(DEFAULTS);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      const merged = { ...DEFAULTS, ...data };
      setB(merged);
      applyCssVars(merged);
    } catch (e) {
      applyCssVars(DEFAULTS);
    }
  }, []);

  useEffect(() => {
    applyCssVars(DEFAULTS);
    load();
  }, [load]);

  return <BrandingContext.Provider value={{ ...b, reload: load }}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext) || DEFAULTS;
